import './Loader.css';

const Loader = () => (
  <div className="loader-container">
    <div className="loader"></div>
  </div>
);

export default Loader;
